import core from "@gtmhub/core/module";
import ngExtensions from "@gtmhub/shared/ng-extensions/ng-extensions.module";
import { HubFilterCtrl } from "./components/hub-filter.ctrl";
import { TrialInfoCtrl } from "./components/trial-info.ctrl";
import { configurePageTitleChange } from "./pageTitle";
import { DemoBannerComponent } from "./components/demo-banner.component";
import { NavigationComponent } from "./components/navigation.component";
import { HelpCenterComponent } from "./components/help-center/help-center.component";
import { downgradeComponent } from "@angular/upgrade/static";
import { NavigationV2Component } from "@webapp/navigation/components/navigation/navigation.component";
import { NavigationWrapperComponent } from "./components/navigation-wrapper/navigation-wrapper.component";
import { ExpandNavV2Service } from "./expand-nav-v2.service";
import { ToggleNavComponent } from "@webapp/navigation/components/toggle-navigation/toggle-nav.component";

const mod = angular.module("navigation", [core, ngExtensions]);
mod.component("navigation", NavigationComponent);
mod.component("demoBanner", DemoBannerComponent);
mod.component("helpCenter", HelpCenterComponent);
mod.component("navigationWrapper", NavigationWrapperComponent);
mod.controller("HubFilterCtrl", HubFilterCtrl);
mod.controller("TrialInfoCtrl", TrialInfoCtrl);
mod.directive("navigationV2", downgradeComponent({ component: NavigationV2Component }));
mod.directive("toggleNavV2", downgradeComponent({ component: ToggleNavComponent }));
mod.service("ExpandNavV2Service", ExpandNavV2Service);

configurePageTitleChange(mod);

export default mod.name;
